export default __webpack_public_path__ + "images/uebergaben/amann_peter.jpg";